import { BPReconfirmationClose } from 'legacy/hpscoutso/components/widgets/public/guestLogin/BPReconfirmationClose'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { DisplayRejectionReason as ReconfirmationDisplayRejectionReason } from 'legacy/lut/components/widgets/public/onboarding/bpReconfirmation/DisplayRejectionReason'
import { DisplayRejectionReason as BPDisplayRejectionReason } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/DisplayRejectionReason'
import { getTypeAndPage } from 'legacy/lut/components/widgets/public/onboarding/helpers/getTypeAndPageByUrl'
import React, { useContext, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'
import {
  Controller,
  isValidEmail,
  ValidateInput,
  ValidationStatus,
} from 'core-components/library/validation'
import { LanguageContext } from 'onboarding/context/LanguageContext'
import { useRegistrationLogin } from 'onboarding/hooks/registration/useRegistrationLogin'

import styles from './RegistrationGuestLogin.module.scss'

export const RegistrationGuestLogin = () => {
  const [email, setEmail] = useState('')
  const [canSave, setCanSave] = useState(true)
  const [warningMessage, setWarningMessage] = useState('')
  const [requestWasRejected, setRequestWasRejected] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation()
  const typeAndPage = getTypeAndPage(location.pathname)

  const { login } = useRegistrationLogin({
    email,
    requestType: typeAndPage?.requestType,
    changeWarningMessage: setWarningMessage,
    changeIsLoading: setIsLoading,
    changeRequestWasRejected: setRequestWasRejected,
  })

  const { t } = useContext(LanguageContext)

  if (location.pathname.includes('bp-reconfirmation')) {
    return <BPReconfirmationClose />
  }

  if (warningMessage && !isLoading) {
    if (requestWasRejected) {
      switch (typeAndPage?.requestType) {
        case RequestTypes.BPReconfirmation:
          return <ReconfirmationDisplayRejectionReason text={warningMessage} t={t} />
        case RequestTypes.BPRegistration:
          return <BPDisplayRejectionReason text={warningMessage} />

        default:
          return <BPDisplayRejectionReason text={warningMessage} />
      }
    }
    return <p className={styles.warning}>{warningMessage}</p>
  }

  return (
    <div>
      <LoaderOverlay show={isLoading} />
      <div className={styles.description}>To start your registration please enter your email</div>
      <Controller
        onValidationStatusChange={({ status }) => {
          if (status !== ValidationStatus.WIP) {
            setCanSave(status === ValidationStatus.Valid)
          }
        }}
      >
        <ValidateInput
          label={'Enter email'}
          value={email}
          onChange={(value) => setEmail(value.trim())}
          checkFn={isValidEmail}
          margin={'sm'}
        />
      </Controller>
      <Button
        className={styles.buttonSignIn}
        disabled={!email || !canSave}
        variant={'outlined'}
        onClick={login}
      >
        GO
      </Button>
    </div>
  )
}
